import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import back from "../../assets/back.svg";
import edit from "../../assets/icons/edit.svg";
import delet from "../../assets/icons/delete-bin.svg";
import DeleteBtn from "../../components/buttons/deleteBtn";
import EditBtn from "../../components/buttons/editBtn";
import VersionHistoryBtn, {
  AdminButton,
} from "../../components/buttons/versionHistoryBtn";
import DeleteModal from "../../components/modals/deleteModal";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import ProductBasic from "../../components/productDetail/productBasic";
import ProductOffer from "../../components/productDetail/productOffer";
import {
  productDelete,
  productDetail,
  productEnableDisable,
} from "../../redux/actions/productActions";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import "./product.css";
import DeletedPopUp from "../../components/popups/DeletedPopUp";
import ErrorPopup from "../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";

const ProductDetail = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [productDetailData, setProductDetailData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [showDisable, setShowDisable] = useState(false);
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [divisionList, setDivisionList] = useState([]);
  const [offerType, setOfferType] = useState("");
  const [deletedPop, setDeletedPop] = useState(false);
  const [enabledDisable, setEnabledDisable] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showErrorPopup1, setShowErrorPopup1] = useState(false);
  const [showErrorMsg1, setShowErrorMsg1] = useState("");
  const [loading, setLoading] = useState(false);

  const [userData, setUserData] = useState(null);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Product" && item
      );

      setUserData(permissionValue);
    }
  }, []);
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    dispatch(productDetail(params.id, onSuccess, onError));
  }, []);
  const onSuccess = (data) => {
    setLoading(false);
    setProductDetailData(data.data.data);
    setOfferType(data?.data?.data?.vendorDivision?.offer_type);
  };

  const onError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const enableShowfunc = () => {
    setOnEnableShow(true);
  };
  const showDel = () => {
    setShowDelete(!showDelete);
  };
  const showdisable = () => {
    setShowDisable(!showDisable);
  };

  const delFunc = () => {
    dispatch(productDelete(params.id, onDelSuccess, onDeleteError));
  };

  const onDelSuccess = (data) => {
    console.log(data);
    setShowDelete(false);
    setDeletedPop(true);

    const timeOutFnc = () => {
      setDeletedPop(false);
      navigate("/product");
    };
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onDeleteError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const enableDisableFunc = (id) => {
    dispatch(
      productEnableDisable(id, onEnableDisableSuccess, onEnableDisableError)
    );
  };

  const onEnableDisableSuccess = (data) => {
    console.log(data);
    dispatch(productDetail(params.id, onSuccess, onError));

    setOnEnableShow(false);
    setEnabledDisable(true);

    const timeOutFnc = () => {
      setEnabledDisable(false);
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup1 = () => {
    setShowErrorPopup1(false);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
    setShowErrorPopup1(true);
    const str1 = err.data.message;
    const str_modify1 = str1.charAt(0).toUpperCase() + str1.slice(1);
    setShowErrorMsg1(str_modify1);
  };

  console.log(offerType);
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Edit
    </Tooltip>
  );
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    { path: "/product", breadcrumb: " / product" },
    {
      path: "/product/view/:id",
      breadcrumb: productDetailData?.product_id
        ? ` / ${productDetailData?.product_id} - view`
        : " / view",
    },
  ];
  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <div className="search-container d-flex justify-content-between ">
              <div
                className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                onClick={() => navigate(-1)}
              >
                <img src={back} alt="back_btn" />
                <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                  BACK
                </span>
              </div>
              <div className=" d-flex justify-content-between align-items-center m-1 mb-2 py-2">
                <VersionHistoryBtn
                  link={`/product/version-history-detail/${productDetailData.id}`}
                />
                {(user_type == "super_user" && userData?.write) ||
                  (user_type == "vendor" && (
                    <>
                      <div className="d-none d-lg-block">
                        <div className="d-flex">
                          <EditBtn
                            link={`/product/edit/${productDetailData.id}`}
                          />
                          <DeleteBtn deleteFn={showDel} />
                        </div>
                      </div>
                      {/* <EnableDisableBtn enableDisableFn={enableShowfunc} /> */}
                      <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <button
                          className="edit-small-btn px-3 mx-1 d-lg-none"
                          onClick={() =>
                            navigate(`/product-edit/${productDetailData.id}`)
                          }
                        >
                          <img src={edit} alt="edit" />
                        </button>
                      </OverlayTrigger>
                      <button
                        className="delete-small-btn px-3 mx-2 me-3 d-lg-none"
                        onClick={() => setShowDelete(true)}
                      >
                        <img src={delet} alt="delete" />
                      </button>
                      <AdminButton
                        color={
                          productDetailData?.status ? "#FF6F5B" : "#24D626"
                        }
                        border={
                          productDetailData?.status
                            ? "1px solid #FF6F5B"
                            : "1px solid #24D626"
                        }
                        width="110px"
                        onClick={() => setOnEnableShow(true)}
                      >
                        <span className="m-2">
                          {productDetailData?.status ? "DISABLE" : "ENABLE"}
                        </span>
                      </AdminButton>
                    </>
                  ))}
              </div>
            </div>
            <div style={{ position: "relative" }}>
              {loading == true ? (
                <div className="list-spinner-container">
                  <LoadingSpinnerTable />
                </div>
              ) : (
                <>
                  <div className="scrolling">
                    <div className="main-view-page">
                      <ProductBasic basicDetails={productDetailData} />

                      <div className="mb-4">
                        <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
                          Batch Pricing
                        </div>
                        {productDetailData?.productBatchPricings?.map(
                          (productItem, index) => (
                            <div className="default-container ms-1">
                              <div className="d-flex align-items-center gap-lg-4">
                                <div className="id-container ">
                                  <p className="label-id color_747f9e">ID</p>
                                  <p className="id-number">#{index + 1}</p>
                                </div>
                                <div className="id-container ">
                                  <p className="label-id color_747f9e">
                                    Quantity
                                  </p>
                                  <p className="id-number">
                                    {productItem?.quantity ?? "--"}
                                  </p>
                                </div>
                                <div className="d-flex overflow-auto align-items-center  pb-2">
                                  <div className="id-container-w1">
                                    <p className="label-id color_747f9e">
                                      Offer Qty
                                    </p>
                                    <p className="id-number">
                                      {productItem?.offer_qty ?? "--"}
                                    </p>
                                  </div>
                                  <div className="id-container-w1">
                                    <p className="label-id color_747f9e">
                                      Integral Qty
                                    </p>
                                    <p className="id-number">
                                      {productItem?.integral_qty ?? "--"}
                                    </p>
                                  </div>
                                  <div className="id-container-w1">
                                    <p className="label-id color_747f9e">MRP</p>
                                    <p className="id-number">
                                      {productItem?.mrp ?? "--"}
                                    </p>
                                  </div>
                                  <div className="id-container-w1">
                                    <p className="label-id color_747f9e">PTR</p>
                                    <p className="id-number">
                                      {productItem?.ptr ?? "--"}
                                    </p>
                                  </div>
                                  <div className="id-container-w1">
                                    <p className="label-id color_747f9e">PTS</p>
                                    <p className="id-number">
                                      {productItem?.pts ?? "--"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>

                      <ProductOffer
                        offerType={offerType}
                        offersList={productDetailData?.productStateOffers}
                        holding_value_unit={
                          productDetailData?.productPackingDetail
                            ?.holding_value_unit
                        }
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <DeleteModal
          show={showDelete}
          handleClose={showDel}
          delFunc={delFunc}
          title={`Product - ${productDetailData?.product_id}`}
        />
        <DeletedPopUp
          title={`Product - ${productDetailData?.product_id}`}
          show={deletedPop}
        />
        <EnableDisableModal
          title={`Product - ${productDetailData?.product_id}`}
          enableDisableFunc={enableDisableFunc}
          handleClose={() => setOnEnableShow(false)}
          id={productDetailData?.id}
          status={productDetailData?.status}
          show={onEnableShow}
        />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
        <ErrorPopup
          show={showErrorPopup1}
          title={showErrorMsg1}
          handleClose={closeErrorPopup1}
        />
      </div>
    </>
  );
};

export default ProductDetail;
